export default "/images/vendor/flag-icon-css/flags/1x1/mo.svg?471093dd27006e1affb75aad55ab1635";